import "./App.css";
import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation
} from "react-router-dom";
import Nav from "./components/nav/nav";
//@ts-ignore
import { PostHogProvider } from "posthog-js/react";
import ReactGA from "react-ga4";
import AdminPanel from "./admin-panel/admin-panel";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import PageCard from "./test-2/PageCard";
import PageCard2 from "./test-2/PageCard2";
//@ts-ignore
import { newAgentCategories } from "./test-2/utils/newPageBuilder";
import axios from "axios";
if (process.env.NODE_ENV === "production") ReactGA.initialize("G-1K4C30KRNE");

const options = {
  api_host: process.env.REACT_APP_PUBLIC_POSTHOG_HOST
};

const queryClient = new QueryClient();

const AppContent = () => {
  type CategoryKey =
    | "Default"
    | "Starbucks"
    | "Travel"
    | "Hospitality"
    | "Retail";

  interface Page {
    page_id: string;
    page_path: string;
    page_title: string;
    page_description: string;
    page_category: string;
  }

  return (
    <section className="nurix-section">
      <div className="container pb-32 md:pb-0">
        <div className="overlay-content">
          <Routes>
            {Object.entries(newAgentCategories).map(([key, item]) => (
              <Route
                key={key}
                path={'*'}
                element={
                  <PageCard
                    page_path={"unifi"}
                    page_title={"Experience Our Voice AI Agents"}
                    page_category={"Unifi"}
                  />
                }
              />
            ))}
          </Routes>
        </div>
      </div>
    </section>
  );
};

const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <PostHogProvider
          apiKey={process.env.REACT_APP_PUBLIC_POSTHOG_KEY}
          options={options}
        >
          <GoogleReCaptchaProvider
            reCaptchaKey={process.env.REACT_APP_RECAPTCHA_SITE_KEY as string}
          >
            <Routes>
              <Route path="/*" element={<AppContent />} />
            </Routes>
          </GoogleReCaptchaProvider>
        </PostHogProvider>
      </Router>
    </QueryClientProvider>
  );
};

export default App;
